import { render, staticRenderFns } from "./WaitingTehBookingFailPopup.vue?vue&type=template&id=b5fc5422&scoped=true"
import script from "./WaitingTehBookingFailPopup.vue?vue&type=script&lang=js"
export * from "./WaitingTehBookingFailPopup.vue?vue&type=script&lang=js"
import style0 from "./WaitingTehBookingFailPopup.vue?vue&type=style&index=0&id=b5fc5422&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5fc5422",
  null
  
)

export default component.exports